// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
  if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
    return true;
  }

  const { fields } = state;

  // for (const name in validFields) {
  //   if (validFields[name] === false) {
  //     return false;
  //   }
  // }

  if (
    !fields.checkbox_autogiro_single.checked &&
    !fields.checkbox_autogiro_monthly.checked
  ) {
    return false;
  }

  if (fields.checkbox_autogiro_single.checked) {
    if (!optionsListValueSelected(fields.customer_autogiro_single_amount)) {
      return false;
    }
    if (
      fields.customer_autogiro_single_amount.options[2].checked &&
      fields.customer_autogiro_single_amount_other.length <= 0
    ) {
      return false;
    }
  }

  if (fields.checkbox_autogiro_monthly.checked) {
    if (!optionsListValueSelected(fields.customer_autogiro_monthly_amount)) {
      return false;
    }

    if (
      fields.customer_autogiro_monthly_amount.options[2].checked &&
      fields.customer_autogiro_monthly_amount_other.length <= 0
    ) {
      return false;
    }
  }

  return true;
}

function optionsListValueSelected(optionsList) {
  const options = optionsList.options;
  for (let i = 0; i < options.length; i++) {
    if (options[i].checked) {
      return true;
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/routes/Cob/views/AmountSelectionSwishMC/AmountSelection.fulfillment.js